import {useEffect, useState} from 'react'
import {Button, Badge, OverlayTrigger, Tooltip, Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'

import {useLazyQuery} from '@apollo/client'
import {KTCard, KTCardBody, KTIcon} from '../../../../_metronic/helpers'
import {BreadcrumbAlmamotors} from '../../components/BreadcrumbAlmamotors'
import {parseId} from '../../helpers'
import {GET_ALL_USERS} from '../../graphql/queries/usersQuery'
import {IDataUsers, ListUsersNode} from '../../graphql/types/usersTypes'
import {Link} from 'react-router-dom'
import {useDisclosure} from '../../hooks/useDisclosure'
import {ModalAddUser} from './components/ModalAddUser'
import {ModalEditUser} from './components/ModalEditUser'

export const AllUsersPage = () => {
  const [gqlGetAllClients, {data, loading, error, refetch}] = useLazyQuery<IDataUsers>(
    GET_ALL_USERS,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const [searchTerm, setSearchTerm] = useState('')
  const [offset, setOffset] = useState(0)
  const [isPagination, setIsPagination] = useState(false)
  const [isSearch, setIsSearch] = useState(false)
  const [dataArr, setDataArr] = useState<IDataUsers['listUsers']['edges']>([])

  const [userInfo, setUserInfo] = useState<null | ListUsersNode>(null)
  const {isOpen, onClose, onOpen} = useDisclosure()
  const {isOpen: isOpenEdit, onClose: onCloseEdit, onOpen: onOpenEdit} = useDisclosure()

  useEffect(() => {
    const variables: {offset: number; email?: string} = {
      offset,
    }
    if (searchTerm) {
      variables.email = searchTerm
    }
    gqlGetAllClients({
      variables,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset, searchTerm])

  useEffect(() => {
    if (error) {
      toast.error(`Error: ${error.message}`)
    }
  }, [error])

  useEffect(() => {
    if (!data) return
    setIsSearch(false)
    if (isPagination) {
      setDataArr((prev) => [...prev, ...data.listUsers.edges])
      return
    }
    setDataArr(data.listUsers.edges)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleSubmitSearchName = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const {name} = Object.fromEntries(new FormData(e.currentTarget))
    if (name.toString() === '') {
      setOffset(0)
      setSearchTerm('')
      return
    }
    if (name.toString().length < 3) return
    setSearchTerm(name.toString())
    setIsSearch(true)
  }

  if (loading && !isPagination && !isSearch) {
    return (
      <div>
        <BreadcrumbAlmamotors
          title='Lista de Usuarios'
          breadcrumb={[
            {
              title: 'CRM',
              path: '/dashboard',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '',
              path: '',
              isSeparator: true,
              isActive: false,
            },
          ]}
          isBtns
          children={
            <>
              {/* {hasPermission(permissions, ALL_PERMISSIONS.PUEDE_AGREGAR_Usuario) ? ( */}
              <Button className='d-flex align-items-center gap-1' disabled>
                <i className='fa fa-plus' /> Agregar Usuario
              </Button>
              {/*  ) : null} */}
            </>
          }
        />
        <KTCard>
          <div style={{height: '40vh'}}>
            <KTCardBody className='py-4 d-flex align-items-center justify-content-center h-100'>
              <Spinner animation='border' />
            </KTCardBody>
          </div>
        </KTCard>
      </div>
    )
  }

  return (
    <div>
      <BreadcrumbAlmamotors
        title='Lista de Usuarios'
        breadcrumb={[
          {
            title: 'CRM',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
        isBtns
        children={
          <>
            {/* {hasPermission(permissions, ALL_PERMISSIONS.PUEDE_AGREGAR_Usuario) ? ( */}
            <Button className='d-flex align-items-center gap-1' onClick={onOpen}>
              <i className='fa fa-plus' /> Agregar Usuario
            </Button>
            {/*  ) : null} */}
          </>
        }
      />

      <KTCard>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            {/* begin::Search */}
            <form onSubmit={handleSubmitSearchName}>
              <div className='d-flex align-items-center position-relative my-1'>
                <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                <input
                  type='search'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-solid w-250px ps-14'
                  placeholder='Correo de usuario'
                  name='name'
                />
              </div>
            </form>
            {/* end::Search */}
          </div>
          {loading && isSearch && <Spinner animation='border' size='sm' />}
          {/* begin::Card toolbar */}
          {/*  <div className='card-toolbar'>
            {/* begin::Group actions
            <UsersListToolbar />
            {/* end::Group actions 
          </div> */}
          {/* end::Card toolbar */}
        </div>
        <KTCardBody className='py-4'>
          <div className='table-responsive'>
            {dataArr.length > 0 ? (
              <table
                id='kt_table_users'
                className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
              >
                <thead className='fw-bold'>
                  <tr className='text-start text-gray-900 fw-bold fs-7 text-uppercase gs-0'>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th>Activo</th>
                    <th />
                  </tr>
                </thead>
                <tbody className='text-gray-700'>
                  {dataArr.map(({node}) => (
                    <tr key={node.id}>
                      <td>
                        {node.firstName} {node.lastName}
                      </td>
                      <td>{node.email}</td>
                      <td>
                        {node.isActive ? (
                          <Badge bg='success'>SI</Badge>
                        ) : (
                          <Badge bg='dark' className='text-light'>
                            NO
                          </Badge>
                        )}
                      </td>
                      <td>
                        <div>
                          <OverlayTrigger
                            overlay={(props) => (
                              <Tooltip id={`button-tooltip-${parseId(node.id)}`} {...props}>
                                Ver
                              </Tooltip>
                            )}
                          >
                            <Link
                              to={`/user/${parseId(node.id)}`}
                              className='btn-outline-dark btn btn-sm'
                              target='_blank'
                            >
                              <i className='fa fa-eye' style={{color: 'inherit'}} />
                            </Link>
                          </OverlayTrigger>
                          <OverlayTrigger
                            overlay={(props) => (
                              <Tooltip id={`button-price-${parseId(node.id)}`} {...props}>
                                Editar
                              </Tooltip>
                            )}
                          >
                            <Button
                              variant='outline-dark'
                              size='sm'
                              onClick={() => {
                                onOpenEdit()
                                setUserInfo(node)
                              }}
                            >
                              <i className='fa fa-pencil' style={{color: 'inherit'}} />
                            </Button>
                          </OverlayTrigger>
                        </div>
                        {/* <button
                          className='border-0 p-0 m-0 bg-transparent hover-bg-color-dark text-secondary'
                          onClick={() => setIdCanteraEdit(node.id)}
                          title='Ver'
                        >
                          <i className='fa fa-eye' style={{color: 'inherit'}} />
                        </button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div
                className='d-flex text-center w-100 align-items-center justify-content-center'
                style={{height: '30vh'}}
              >
                <div>No hay Usuarios registrados</div>
              </div>
            )}
          </div>
          {loading && isPagination && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Spinner animation='border' size='sm' />
            </div>
          )}
          {data?.listUsers.pageInfo.hasNextPage && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Button
                size='sm'
                variant='info'
                onClick={() => {
                  setIsPagination(true)
                  setOffset((pre) => pre + 10)
                }}
              >
                Cargar más usuarios
              </Button>
            </div>
          )}
          {/* {isLoading && <UsersListLoading />} */}
        </KTCardBody>
      </KTCard>

      {isOpen && <ModalAddUser isOpen={isOpen} onClose={onClose} refetch={refetch} />}
      {isOpenEdit && userInfo && (
        <ModalEditUser
          user={userInfo}
          isOpen={isOpenEdit}
          onClose={onCloseEdit}
          refetch={refetch}
        />
      )}

      {/* <Modal show={showModalCreateUpdate} onHide={handleClose}>
        <BootstrapForm onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>{idUsuariodit ? 'Editar' : 'Crear'} Usuario</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container className='d-flex flex-column gap-4'>
              <BootstrapForm.Group controlId='name'>
                <BootstrapForm.Label>Nombre:</BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  placeholder='Ingrese el nombre'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  isInvalid={formik.touched.name && !!formik.errors.name}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.name}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId='nit'>
                <BootstrapForm.Label>NIT:</BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  placeholder='Ingrese el nit'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.nit}
                  isInvalid={formik.touched.nit && !!formik.errors.nit}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.nit}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId='phoneNumber'>
                <BootstrapForm.Label>Número de teléfono:</BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  placeholder='Ingrese el número de teléfono'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phoneNumber}
                  isInvalid={formik.touched.phoneNumber && !!formik.errors.phoneNumber}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.phoneNumber}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId='address'>
                <BootstrapForm.Label>Dirección:</BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  placeholder='Ingrese el dirección'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address}
                  isInvalid={formik.touched.address && !!formik.errors.address}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.address}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId='postpaidSales'>
                <BootstrapForm.Label>¿Acepta Postpago?</BootstrapForm.Label>
                <BootstrapForm.Select
                  aria-label='postpaidSales'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.postpaidSales}
                  isInvalid={formik.touched.postpaidSales && !!formik.errors.postpaidSales}
                >
                  <option value=''>NO</option>
                  <option value='SI'>SI</option>
                </BootstrapForm.Select>
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.postpaidSales}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type='button'
              variant='secondary'
              onClick={() => {
                handleClose()
                setIdUsuariodit(null)
                formik.resetForm()
              }}
            >
              Cancelar
            </Button>
            <Button
              type='submit'
              variant='primary'
              disabled={loadingCreate}
              className='d-flex align-items-center gap-2'
            >
              {loadingCreate && <Spinner color='light' size='14px' />}
              // <Spinner color='light' size='14px' /> 
              {idUsuariodit ? 'Editar' : 'Agregar'} Usuario
            </Button>
          </Modal.Footer>
        </BootstrapForm>
      </Modal>

      {isOpen && infoPriceClient && (
        <ModalViewPrices
          isOpen={isOpen}
          onClose={onClose}
          infoPriceClient={infoPriceClient}
          onOpenAddPrice={onOpenAddPrice}
          updateInfoAddPrice={updateInfoAddPrice}
        />
      )}
      {isOpenAddPrice && infoAddPrice && (
        <ModalAddPrice
          isOpen={isOpenAddPrice}
          onClose={onCloseAddPrice}
          infoAddPrice={infoAddPrice}
          refetch={refetch}
        />
      )} */}
    </div>
  )
}
